import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AvstemningMedMøteModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatIcon} from "@angular/material/icon";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {TranslateModule} from "@ngx-translate/core";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {MatTooltip} from "@angular/material/tooltip";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {gruppefargeNilsikker} from "felles-ng2/modell/Gruppefarge";
import {MatButton} from "@angular/material/button";
import {KlikkMedStopPropagationDirektiv} from "web-ng2/delt/direktiver/klikkMedStopPropagation/klikkMedStopPropagation";

const debug = initDebugger('AvstemningManglerBrukersStemmeKomponent');

/**
 * Viser avstemning som mangler brukers stemme
 */
@Component({
    selector: 'avstemning-mangler-brukers-stemme',
    templateUrl: 'avstemning-mangler-brukers-stemme.html',
    styleUrl: 'avstemning-mangler-brukers-stemme.scss',
    host: {'(click)': 'gaaTilAvstemning()'},
    imports: [
        MatIcon,
        TranslateModule,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe,
        MatTooltip,
        MatButton,
        KlikkMedStopPropagationDirektiv
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvstemningManglerBrukersStemmeKomponent {

    manglerStemmegivning = input.required<AvstemningMedMøteModell>();

    gruppe = computed(() => this.kontekst.autentisertBruker().finnAutentiserteGruppe(this.manglerStemmegivning().avstemning.eiendeGruppeId));
    gruppefarge = computed(() => gruppefargeNilsikker(this.gruppe()));

    constructor(private navigasjon: Navigasjon, private kontekst: BrukerkontekstTilbyder) {
    }

    gaaTilSak() {
        const avstemning = this.manglerStemmegivning();
        this.navigasjon.gåTilMøteOgSak(avstemning.moeteId, avstemning.sakId);
    }

    gaaTilAvstemning() {
        const avstemning = this.manglerStemmegivning();
        this.navigasjon.gåTilAvstemning(avstemning.avstemning.id, avstemning.sakId, avstemning.moeteId);
    }
}

